import {BenjiKIVSymbolStates, SymbolPositionData} from "../../core/reel/ReelInterfaces";
import {BenjiKIVSymbol} from "../reels/BenjiKIVSymbol";
import {BenjiKIV} from "../BenjiKIV";

/**
 * Created by jonas on 2021-02-19.
 */

export class SymbolUtils {

    public static createSymbol(isStopping:boolean, symbolName:string, state:BenjiKIVSymbolStates, symbolPositionData:SymbolPositionData):BenjiKIVSymbol {
        if(symbolName.length > 2) {
            if(symbolName == "W_MID") {
                return BenjiKIV.wildSymbolsPool.getSymbol(symbolName, symbolPositionData).init(state);
            } else if(symbolName == "M1_MID" || symbolName == "M2_MID" || symbolName == "M3_MID") {
                return BenjiKIV.stackedSymbolsPool.getSymbol(symbolName, symbolPositionData).init(state);
            }
        }
        //Don't use pooled scatters during spin
        if(symbolName == "S" && (isStopping == true || BenjiKIV.model.isRestore == true)) {
            return BenjiKIV.scatterPool.getSymbol(symbolName, symbolPositionData).init(state);
        }

        return BenjiKIV.symbolsPool.getSymbol(symbolName, symbolPositionData).init(state);
    }
}